import lodash from 'lodash';
import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Tooltip,
    withStyles,
    Icon,
    IconButton,
    TablePagination,
} from '@material-ui/core';
import { Modal, Tag } from 'antd';
import { users_actions } from '../redux/actions/users.actions';
import { changeUserStatusRequest } from '../redux/actions/change_user_status.actions';
import { table_styles } from '../../../../components/TableStyles';
import { debounce } from '../../../../shared/helpers';
import TableLoader from '../../../../components/table/TableLoader';
import TableNoData from '../../../../components/table/TableNoData';

const { confirm } = Modal;
const tableCols = [
    { content: '#', width: '1%', align: 'center' },
    { content: 'First Name', align: 'left' },
    { content: 'Last Name', align: 'left' },
    { content: 'Username', align: 'left' },
    { content: 'Department', width: '5%', align: 'center' },
    { content: 'Status', width: '5%', align: 'center' },
    {
        content: <Tooltip title="Actions" placement="top">
            <div style={{ marginTop: '5px' }}>
                <Icon fontSize="small">flash_on</Icon>
            </div>
        </Tooltip>,
        width: '5%',
        align: 'center',
    },
];

class UsersList extends Component {
    local_path = 'User_list_table.filters';

    componentDidMount() {
        this.requestData(true);
    }

    requestData = init => this.props.dispatch(users_actions.getUsersRequest(this.props.filters, init));

    runFetch = debounce(this.requestData, 500);

    handleChangePage = (event, page) => {
        const { dispatch } = this.props;
        dispatch(users_actions.setFilter(`${this.local_path}.offset`, page * this.props.filters.limit));
        dispatch(users_actions.setFilter(`${this.local_path}.page`, page));
        this.runFetch();
    };

    handleChangeRowsPerPage = (event) => {
        const { dispatch } = this.props;
        dispatch(users_actions.setFilter(`${this.local_path}.limit`, event.target.value));
        dispatch(users_actions.setFilter(`${this.local_path}.offset`, 0));
        dispatch(users_actions.setFilter(`${this.local_path}.page`, 0));
        this.runFetch();
    };

    handleSearch = (event) => {
        this.props.dispatch(users_actions.setFilter(`${this.local_path}.searchText`, event.target.value));
        this.runFetch();
    };

    confirmChangeStatus = (user) => {
        confirm({
            title: user.status.name === 'Active' ? 'Are you sure block this user?' : 'Are you sure unblock this user?',
            okText: 'Confirm',
            cancelText: 'Cancel',
            onOk: () => {
                const changedStatus = user.status.name === 'Active'
                    ? { name: 'Suspended', _id: '5bbb0a0160dc39407f5623ab' }
                    : { name: 'Active', _id: '5bbb09fb60dc39407f5623aa' };

                this.props.dispatch(changeUserStatusRequest({ _id: user.id, status: changedStatus }, this.requestData));
            },
        });
    };

    render() {
        const { classes: { table }, data_count, filters } = this.props;

        return (
            <Fragment>
                <Paper>
                    <Table className={`${table} sbf-table`}>
                        <TableHead>
                            <TableRow>
                                {
                                    tableCols.map((title, index) => (
                                        <TableCell
                                            key={index}
                                            align={title.align}
                                            style={{
                                                width: [title.width],
                                            }}
                                        >
                                            {title.content}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                this.props.loading
                                    ? <TableLoader colSpan={tableCols.length} />
                                    : this.props.data && this.props.data.map((item, index) => {
                                        const firstName = item.cells[0];
                                        const lastName = item.cells[1];
                                        const email = item.cells[2];
                                        const department = item.cells[3];
                                        const userStatus = lodash.get(item, 'ref_user_status.name');
                                        const isActiveUser = userStatus === 'Active';

                                        return (
                                            <TableRow key={item.id}>
                                                <TableCell align={tableCols[0].align}>
                                                    <span>{index + 1}</span>
                                                </TableCell>
                                                <TableCell align={tableCols[1].align}>
                                                    <span>{firstName}</span>
                                                </TableCell>
                                                <TableCell align={tableCols[2].align}>
                                                    <span>{lastName}</span>
                                                </TableCell>
                                                <TableCell align={tableCols[3].align}>
                                                    <span>{email}</span>
                                                </TableCell>
                                                <TableCell align={tableCols[4].align}>
                                                    <span>{department}</span>
                                                </TableCell>
                                                <TableCell align={tableCols[5].align}>
                                                    {
                                                        item.ref_user_status.name === 'Active'
                                                            ? <Tag color="green" style={{ margin: '0' }}>Active</Tag>
                                                            : item.ref_user_status.name === 'Suspended'
                                                                ? <Tag color="red" style={{ margin: '0' }}>Suspended</Tag>
                                                                : <Tag color="orange" style={{ margin: '0' }}>{item.ref_user_status.name}</Tag>
                                                    }
                                                </TableCell>
                                                <TableCell align={tableCols[6].align}>
                                                    <div style={{ display: 'inline-flex' }}>
                                                        <Tooltip title={isActiveUser ? 'Disable Account' : 'Enable Account'} placement="top">
                                                            <IconButton
                                                                color="primary"
                                                                aria-label="Active/inactive user"
                                                                style={{ padding: 5 }}
                                                                onClick={() => this.confirmChangeStatus({
                                                                    id: item.ref_user_id,
                                                                    status: item.ref_user_status,
                                                                })}
                                                            >
                                                                <Icon fontSize="small" color={isActiveUser ? 'error' : 'primary'}>{isActiveUser ? 'lock' : 'lock_open'}</Icon>
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Open User Details" placement="top">
                                                            <span>
                                                                <IconButton
                                                                    color="primary"
                                                                    aria-label="Open user profile"
                                                                    style={{ padding: 5 }}
                                                                >
                                                                    <Link style={{ lineHeight: '20px' }} to={!this.props.user_profile_access ? { pathname: `/UserManagement/User_profile/${item.id}` } : { pathname: '' }}>
                                                                        <Icon fontSize="small" color="action">manage_accounts</Icon>
                                                                    </Link>

                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                            }
                            {
                                !this.props.loading && lodash.isEmpty(this.props.data) && <TableNoData colSpan={tableCols.length} />
                            }
                        </TableBody>
                    </Table>
                    <TablePagination
                        component="div"
                        count={data_count || 0}
                        rowsPerPage={filters.limit}
                        page={filters.page}
                        backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                        nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </Paper>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        User_list: {
            init_loading,
            User_list_table: {
                data, data_count, error, filters, loading,
            },
        },
    } = state.UserManagement;
    return {
        init_loading, data, data_count, error, filters, loading,
    };
};

export default connect(mapStateToProps)(withStyles(table_styles)(UsersList));



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/components/UsersList.js